import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Banana.svg",
  "use": "Banana.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Banana.svg\"><path d=\"M9.9272,41.9828c1.3956,0,4.6919.986,10.0729.986a22.2391,22.2391,0,0,0,21.9867-19c.6355-4.66,3.0132-6.3332,3.0132-8.5,0-3.9723-2.0133-4.7967-2.0133-5.8751,0-.6875,1.125-1.6249,2.875-1.6249,1.7085,0,3.1383.625,3.1383,1.75,0,2.9374-.0033,3.54.4553,5.25.8422,3.1388,4.5314,5.68,4.5314,16a25,25,0,0,1-25,25c-14.551,0-20.9735-9.4566-20.9735-12.1294A2.428,2.428,0,0,1,9.9272,41.9828Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol